export default __webpack_public_path__ + "static/media/trust-wallet.bd6fbac0.svg";